"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ringIAsData = void 0;
exports.ringIAsData = [
    {
        artNr: 'SK20.2.H.5.1',
        ketteArtNr: ['SK20.033.02.1', 'SKS20.033.02.1'],
        innenbreite_mm: 31,
        innenhoehe_mm: 18,
        aussenbreite_mm: 33,
        aussenhoehe_mm: 20,
        staticIaJsons: [
            {
                ArtNr: { DE: 'SK20.2.H.5.1-static1' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 33 / 2 - 5 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK20.2.H.5.1-static2' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 33 / 2 + 5 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
        ],
    },
    {
        artNr: 'SK28.3.H.5.1',
        ketteArtNr: ['SK28.068.02.1', 'SKS28.068.02.1', 'SKY28.068.02.1'],
        innenbreite_mm: 65,
        innenhoehe_mm: 23.6,
        aussenbreite_mm: 68,
        aussenhoehe_mm: 28,
        staticIaJsons: [
            {
                ArtNr: { DE: 'SK28.3.H.5.1-static1' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 68 / 2 - 16.7 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK28.3.H.5.1-static2' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 68 / 2 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK28.3.H.5.1-static3' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 68 / 2 + 16.7 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
        ],
    },
    {
        artNr: 'SK40.2.H.5.1',
        ketteArtNr: ['SK40.085.02.1', 'SKS40.085.02.1'],
        innenbreite_mm: 79.1,
        innenhoehe_mm: 35.8,
        aussenbreite_mm: 85,
        aussenhoehe_mm: 38,
        staticIaJsons: [
            {
                ArtNr: { DE: 'SK40.2.H.5.1-static1' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 85 / 2 - 22.76 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK40.2.H.5.1-static2' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 85 / 2 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK40.2.H.5.1-static3' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 85 / 2 + 22.76 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
        ],
    },
    {
        artNr: 'SK20.2.H.5.J',
        ketteArtNr: ['SK20.033.02.1', 'SKS20.033.02.1'],
        innenbreite_mm: 31,
        innenhoehe_mm: 18,
        aussenbreite_mm: 33,
        aussenhoehe_mm: 20,
        staticIaJsons: [
            {
                ArtNr: { DE: 'SK20.2.H.5.J-static1' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 33 / 2 - 5 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK20.2.H.5.J-static2' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 33 / 2 + 5 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
        ],
    },
    {
        artNr: 'SK28.3.H.5.1.J',
        ketteArtNr: ['SK28.068.02.1', 'SKS28.068.02.1', 'SKY28.068.02.1'],
        innenbreite_mm: 65,
        innenhoehe_mm: 23.6,
        aussenbreite_mm: 68,
        aussenhoehe_mm: 28,
        staticIaJsons: [
            {
                ArtNr: { DE: 'SK28.3.H.5.1.J-static1' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 68 / 2 - 16.7 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK28.3.H.5.1.J-static2' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 68 / 2 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK28.3.H.5.1.J-static3' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 68 / 2 + 16.7 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
        ],
    },
    {
        artNr: 'SK40.3.H.5.1.J',
        ketteArtNr: ['SK40.085.02.1', 'SKS40.085.02.1'],
        innenbreite_mm: 79.1,
        innenhoehe_mm: 35.8,
        aussenbreite_mm: 85,
        aussenhoehe_mm: 38,
        staticIaJsons: [
            {
                ArtNr: { DE: 'SK40.3.H.5.1.J-static1' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 85 / 2 - 22.76 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK40.3.H.5.1.J-static2' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 85 / 2 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
            {
                ArtNr: { DE: 'SK40.3.H.5.1.J-static3' },
                ArtyConnect: '2400',
                IAHKHeight: { Unit: 'mm', Value: 2.3 },
                IAHKH: { Unit: 'mm', Value: 2.3 },
                IAHKB: { Unit: 'mm', Value: 2.5 },
                IAHKRep: 1,
                XPos: { Unit: 'mm', Value: 85 / 2 + 22.76 - 2.5 / 2 },
                YPos: { Unit: 'mm', Value: 0 },
                ZPos: { Unit: 'mm', Value: 0 },
            },
        ],
    },
];
//# sourceMappingURL=ringIAsData.js.map